import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages } from 'react-intl';
import { List } from 'immutable';

import { getItemPrice } from 'selectors/browse';
import { useIsMounted } from 'hooks';
import buildProductsList from './buildProductsList';
import ProductOption from '../OrderCrossSells/ProductOption';

import { CrossSellsContainer, CrossSellList, SliderItem } from '../OrderCrossSells/styles';
import { Title } from '../styles';

const messages = defineMessages({
  title: {
    defaultMessage: 'You may also like',
  },
});

const propTypes = {
  comboUpsellsList: PropTypes.instanceOf(List),
  serviceId: PropTypes.string,
  menuTypeId: PropTypes.number,
  getItemPrice: PropTypes.func,
  onAccept: PropTypes.func,
  comboUpsellMessage: PropTypes.string,
  hideTitle: PropTypes.bool,
};

const defaultProps = {
  serviceId: undefined,
  menuTypeId: undefined,
  onAccept: undefined,
  comboUpsellMessage: undefined,
};

const OrderComboUpsells = ({
  comboUpsellsList, menuTypeId, getItemPrice, onAccept, comboUpsellMessage, hideTitle,
}) => {
  const [comboUpsellProducts, setComboUpsellProducts] = useState(new List());
  const [isMounted] = useIsMounted();

  const productNoImages = comboUpsellProducts.filter(
    item => item.getIn(['product', 'images', 0, 'path'], false) === false
  );
  const showImage = productNoImages.size === 0; // show image only if all products have images

  useEffect(() => {
    if (comboUpsellsList && isMounted.current) {
      setComboUpsellProducts(buildProductsList(comboUpsellsList));
    }
  }, [comboUpsellsList, isMounted]);

  if (!comboUpsellProducts.size) return null;

  return (
    <CrossSellsContainer>
      {!hideTitle && <Title>{comboUpsellMessage || <FormattedMessage {...messages.title} />}</Title>}
      <CrossSellList>
        {comboUpsellProducts.map(item => {
          const productImage = item.getIn(['product', 'images', 0, 'path']) || null;

          const price = getItemPrice(
            item.getIn(['prices', menuTypeId.toString(), 'price']),
            item.getIn(['product', 'tax_categories'])
          );
          const updatedItem = item.set('is_upsell', true);

          return (
            <SliderItem key={updatedItem.get('id')}>
              <ProductOption
                name={updatedItem.getIn(['product', 'name'])}
                price={price}
                imagePath={productImage}
                showImage={showImage}
                onClick={() => onAccept && onAccept(updatedItem)}
              />
            </SliderItem>
          );
        })}
      </CrossSellList>
    </CrossSellsContainer>
  );
};

OrderComboUpsells.propTypes = propTypes;
OrderComboUpsells.defaultProps = defaultProps;

const mapStateToProps = state => ({
  getItemPrice: (price, taxCategories) => getItemPrice(state, price, taxCategories),
});

export default connect(mapStateToProps)(OrderComboUpsells);
